import { render, staticRenderFns } from "./SamsungBrowser.vue?vue&type=template&id=1984fe5e&scoped=true&"
import script from "./SamsungBrowser.vue?vue&type=script&lang=js&"
export * from "./SamsungBrowser.vue?vue&type=script&lang=js&"
import style0 from "./SamsungBrowser.vue?vue&type=style&index=0&id=1984fe5e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1984fe5e",
  null
  
)

export default component.exports